import Dashboard from "views/Dashboard/Dashboard.js";

import Admin from "views/Tables/Admin.js";
import MemberDirectory from "views/Tables/MemberDirectory";
import Projects from "views/Tables/Projects";
import Studies from "views/Tables/Studies";
import DataExport from "views/Tables/DataExport";
import AllStudies from "views/Tables/AllStudies";

import UserProfile from "views/Pages/UserProfile";
import ConferenceRegistration from "views/Pages/ConferenceRegistration";
import Mission from "views/Pages/Mission";
import Leadership from "views/Pages/Leadership";
import Agreement from "views/Pages/Agreement";
import MyConferences from "views/Pages/MyConferences";

import CommonUseDataSets from "views/CommonUseDataSets/CommonUseDataSets";
import MyData from "views/CommonUseDataSets/MyData";
import AdminRequests from "views/CommonUseDataSets/AdminRequests";
import AdminRequestDetail from "views/CommonUseDataSets/AdminRequestDetail";
import Stats from "views/Charts/Stats";
import Dino from "views/Pages/Dino";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import People from "@material-ui/icons/People";
import GridOn from "@material-ui/icons/GridOn";
import Timeline from "@material-ui/icons/Timeline";
import Storage from "@material-ui/icons/Storage";

import Event from "@material-ui/icons/Event";
import ConfirmationNumber from "@material-ui/icons/ConfirmationNumber";

var dashRoutes = [
  ///// HIDDEN ROUTES
  {
    path: "/common-use-data-sets/admin/:id",
    name: "Data Request Review",
    icon: Storage,
    component: AdminRequestDetail,
    layout: "/portal",
  },
  {
    path: "/common-use-data-sets/admin",
    name: "Data Requests",
    icon: Storage,
    component: AdminRequests,
    layout: "/portal",
  },
  {
    path: "/my-data",
    name: "My Data",
    icon: Storage,
    component: MyData,
    layout: "/portal",
  },

  {
    path: "/admin",
    name: "Admin",
    icon: DashboardIcon,
    component: Admin,
    layout: "/portal",
  },

  {
    path: "/profile",
    name: "Profile",
    icon: DashboardIcon,
    component: UserProfile,
    layout: "/portal",
  },

  {
    path: "/my_conferences",
    name: "My Conferences",
    icon: DashboardIcon,
    component: MyConferences,
    layout: "/portal",
  },

  {
    path: "/agreement",
    name: "Agreement",
    mini: "",
    component: Agreement,
    layout: "/portal",
  },

  {
    path: "/studies",
    name: "My PALISI Studies",
    icon: DashboardIcon,
    component: Studies,
    layout: "/portal",
  },

  {
    path: "/all_studies",
    name: "All Studies",
    icon: DashboardIcon,
    component: AllStudies,
    layout: "/portal",
  },
  {
    path: "/data_export",
    name: "Data Export",
    icon: DashboardIcon,
    component: DataExport,
    layout: "/portal",
  },

  ////// Visible ROUTES

  {
    path: "/highlights",
    name: "Highlights",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/portal",
  },
  {
    path: "/mission",
    name: "Mission",
    icon: ConfirmationNumber,
    component: Mission,
    layout: "/portal",
  },
  {
    path: "/leadership",
    name: "Leadership",
    icon: People,
    component: Leadership,
    layout: "/portal",
  },
  {
    path: "/conferences",
    name: "Conferences/Meetings",
    icon: Event,
    component: ConferenceRegistration,
    layout: "/portal",
  },
  {
    path: "/member_directory",
    name: "Member Directory",
    icon: GridOn,
    component: MemberDirectory,
    layout: "/portal",
  },
  {
    collapse: true,
    path: "/projects",
    name: "Projects",
    icon: "content_paste",
    state: "projectsCollapse",
    component: Projects,
    views: [
      {
        path: "/projects",
        name: "Project List",
        mini: "",
        component: Projects,
        layout: "/portal",
      },
      {
        path: "/dino",
        name: "DiNO",
        mini: "",
        component: Dino,
        layout: "/portal",
      },
    ],
    layout: "/portal",
  },

  {
    path: "/common-use-data-sets",
    name: "Common Use Data Sets",
    icon: Storage,
    component: CommonUseDataSets,
    layout: "/portal",
  },

{
    path: "/stats",
    name: "Stats",
    icon: Timeline,
    component: Stats,
    layout: "/portal",
  },
];
export default dashRoutes;

